import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { IsAllowed } from "../../acl";
import apiUrls from "../../api/urls";
import { getAletrnativeImage } from "../../utils/buildingImages";
import CustomizedDialogs from "../Dialog";
import { IconButton } from "../IconButton";
import { Building } from "./types";

export type AssetImagesProps = {
  building: Building | undefined;
  buildingType: "commercial" | "office" | "public" | string;
  imageClassName?: string;
  imgPath?: string;
  upload?: boolean;
};

export const AssetImages = ({ building, buildingType, imageClassName, imgPath, upload = true }: AssetImagesProps) => {
  const [imagePath, setImagePath] = useState(imgPath);
  const { t } = useTranslation();
  useEffect(() => setImagePath(imgPath), [imgPath]);

  if (!building) return null;

  const url = apiUrls.buildingImage.post;
  const queryParams = [{ name: "project", value: building?.id }];
  const onSuccess = (resp: { image_file?: string }) => {
    setImagePath(resp.image_file);
  };

  return (
    <div className="relative">
      {upload && IsAllowed("BUILDING_PROFILE.UPLOAD_IMAGE") && (
        <CustomizedDialogs
          Component={
            <IconButton
              buttonProps={{
                className: "absolute right-3 bottom-3 z-10",
                size: "sm",
                variant: "primary",
              }}
              iconProps={{
                color: "var(--color-foreground-inverse)",
                iconName: "Camera",
              }}
            />
          }
          formDataFileKeyName="image_file"
          headerTitle={t("general.uploadImage") as string}
          onSuccess={onSuccess}
          queryParams={queryParams}
          url={url}
        />
      )}
      <img
        className={`max-h-[420px] min-h-[180px] w-full rounded object-contain object-center drop-shadow ${imageClassName}`}
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          target.onerror = null;
          target.src = getAletrnativeImage(buildingType);
        }}
        src={imagePath}
      />
    </div>
  );
};
